import React from 'react';
import { useLocation } from 'react-router-dom';

import TwoColumn from '../../components/TwoColumn';
import ShiftsList from './ShiftsList';

export default function Shifts() {
  const location = useLocation();

  const active = React.useMemo(() => (location.pathname !== '/shifts'), [location]);

  return (
    <TwoColumn right={active}>
      <TwoColumn.Left>
        <ShiftsList />
      </TwoColumn.Left>
      <TwoColumn.Right />
    </TwoColumn>
  );
}
